import { render, staticRenderFns } from "./DraggableElements.vue?vue&type=template&id=56600797&scoped=true&"
import script from "./DraggableElements.vue?vue&type=script&lang=js&"
export * from "./DraggableElements.vue?vue&type=script&lang=js&"
import style0 from "./DraggableElements.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DraggableElements.vue?vue&type=style&index=1&id=56600797&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56600797",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56600797')) {
      api.createRecord('56600797', component.options)
    } else {
      api.reload('56600797', component.options)
    }
    module.hot.accept("./DraggableElements.vue?vue&type=template&id=56600797&scoped=true&", function () {
      api.rerender('56600797', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/DraggableElements.vue"
export default component.exports